import { isEqual } from 'date-fns';
import { TimesheetEntryType, TimesheetEntry } from '@sdk/timesheets/types/TimesheetEntry';

/**
 * Each Time Clock block (everything that happens between clock in and clock out) is treated separately.
 * This means automated break rules are applied individually and so.
 *
 * This method helps with the extraction of relevant blocks out of all the available blocks.
 */
export const getRelevantTimesheetEntries = (
  allTimesheetEntries: TimesheetEntry[],
  clockIn: Date
) => {
  // Find the relevant start of timesheetEntries based on clock in and clock out times
  const relevantIndex = allTimesheetEntries.findIndex(
    (entry: TimesheetEntry) =>
      entry.type === TimesheetEntryType.clockIn && isEqual(entry.timestamp, clockIn)
  );
  // Prepare relevant timesheetEntries
  return allTimesheetEntries.slice(relevantIndex, allTimesheetEntries.length);
};
